import React from 'react'
import { useGenericRequestHandler } from '../../../handlers/useGenericRequestHandler'
import { getDeviceIdOrAccessTokenHash } from '@mote/helpers/identity'

export const useMoteConversationMutation = (
  moteId,
  refetchInterval = false
) => {
  const json = getDeviceIdOrAccessTokenHash()

  return useGenericRequestHandler({
    route: `v1/m/conversation/${moteId}`,
    method: 'POST',
    options: {
      json
    },
    refetchInterval
  })
}

export function moteConversationDataGetter(data) {
  return {
    canReply: data.conversation.canReply,
    replyMotes: data.conversation.replyMoteStatuses,
    parentMote: {
      currentMoteId: data.conversation.currentMoteId,
      ...data.moteStatus
    }
  }
}
